// @ts-nocheck
import React, { useState } from "react";
import { X } from "lucide-react";
import { Dialog } from "@headlessui/react";
import { toast } from "react-toastify";

const ImagePicker = ({ show, onClose, onImageSelected, profileImageUri }) => {
  const [previewImage, setPreviewImage] = useState(profileImageUri);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!file.type.startsWith("image/")) {
        toast.error("Please select a valid image file.");
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        toast.error("Image size must be less than 5MB.");
        return;
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
      onImageSelected(file);
      onClose();
    }
  };

  if (!show) return null;

  return (
    <Dialog
      open={show}
      onClose={onClose}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40"
    >
      <Dialog.Panel className="relative w-1/4 rounded-xl border border-red-700 bg-black p-5 shadow-xl">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute -top-3 -right-3 z-10 flex h-8 w-8 items-center justify-center rounded-full bg-red-700 text-white"
        >
          <X size={18} />
        </button>

        {/* Profile Image Preview */}
        <img
          src={
            previewImage ||
            "https://encrypted-tbn0.gstatic.com/images?q=trbn:ANd9GcQfj3Bm37Nn_rBQHkIzxnpmGMv3AnLWNYvA1_GwXzebfQ7rxLHl0fRsKo6mIi1SmoOiCL4&usqp=CAU"
          }
          alt="Profile Preview"
          className="mb-6 h-80 w-full object-cover bg-gray-300"
        />

        {/* File Input */}
        <div className="flex justify-center">
          <label className="flex flex-col items-center px-4 py-2 text-white bg-gray-700 rounded hover:bg-gray-600 cursor-pointer">
            <span className="text-sm">Choose Image</span>
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              className="hidden"
            />
          </label>
        </div>
      </Dialog.Panel>
    </Dialog>
  );
};

export default ImagePicker;
